import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceSpecialCharacters'
})
export class ReplaceSpecialCharactersPipe implements PipeTransform {

  replaceCharacterArray: any = {
    'Š': 'S', 'š': 's', 'Ž': 'Z', 'ž': 'z', 'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A',
    'Å': 'A', 'Æ': 'A', 'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I',
    'Í': 'I', 'Î': 'I',
    'Ï': 'I', 'Ñ': 'N',
    'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U',
    'Ý': 'Y', 'Þ': 'B', 'ß': 'Ss', 'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a',
    'æ': 'a', 'ç': 'c', 'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i',
    'ï': 'i', 'ð': 'o', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ø': 'o',
    'ù': 'u', 'ú': 'u', 'û': 'u', 'ý': 'y', 'þ': 'b', 'ÿ': 'y'
  };

  transform(value: any, args?: any): string {

    const spottedCharacteres = [];

    /**
     * Si un caractere special se trouve dans la valeur en parametre 
     * alors on push le caractere dans un tableau pour le remplacer plus tard
     */
    for (const [key, val] of Object.entries(this.replaceCharacterArray)) {
      if (value.includes(key)) {
        spottedCharacteres.push([key, val]);
      }
    }

    /**
     * Pour chaque caractere spécial trouvé on le remplace
     */
    spottedCharacteres.map(data => {
      let regexCaracteres = new RegExp('(' + data[0] + ')', 'g');
      value = value.replace(regexCaracteres, data[1]);
    })

    /**
     * Pareil pour les traits d'union et les guillemets
     */
    value = value.replace("-", " ");
    value = value.replace("'", " ");

    return value.toUpperCase();

  }

}
